var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c("div", { staticClass: "page-header" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center w-100" },
        [
          _c(
            "b-link",
            {
              staticClass: "mr-3",
              on: {
                click: function($event) {
                  return _vm.onBack()
                }
              }
            },
            [
              _c("v-icon", {
                attrs: { name: "buttons/chevrons_left", size: 15 }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("h4", { staticClass: "mr-auto" }, [_vm._v("Акт сверки")]),
          _vm._v(" "),
          _c(
            "b-overlay",
            {
              staticClass: "d-inline-block",
              attrs: {
                show: _vm.loading,
                rounded: "",
                opacity: "0.6",
                "spinner-small": "",
                "spinner-variant": "success"
              },
              on: { hidden: _vm.onHiddenExportButtonOverlay }
            },
            [
              _c(
                "b-button",
                {
                  ref: "export_file_button",
                  staticClass: "custom-btn-secondary mr-1",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.exportFileGate("docx")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { name: "buttons/export", size: 12 } }),
                  _vm._v("\n          Экспорт в Docx\n        ")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-overlay",
            {
              staticClass: "d-inline-block",
              attrs: {
                show: _vm.loading,
                rounded: "",
                opacity: "0.6",
                "spinner-small": "",
                "spinner-variant": "success"
              },
              on: { hidden: _vm.onHiddenExportPdfButtonOverlay }
            },
            [
              _c(
                "b-button",
                {
                  ref: "export_pdf_file_button",
                  staticClass: "custom-btn-secondary mr-1",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.exportFileGate("pdf")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { name: "buttons/export", size: 12 } }),
                  _vm._v("\n          Экспорт в PDF\n        ")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "custom-btn-primary",
              attrs: { disabled: _vm.loading },
              on: {
                click: function($event) {
                  return _vm.handleSubmit()
                }
              }
            },
            [
              _vm.loading
                ? _c("b-spinner", { attrs: { small: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c("v-icon", { attrs: { name: "buttons/check", size: 13 } }),
              _vm._v("\n        Сохранить\n      ")
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-body", staticStyle: { "overflow-y": "auto" } },
      [
        _c("b-skeleton-wrapper", {
          attrs: { loading: _vm.isBusy },
          scopedSlots: _vm._u([
            {
              key: "loading",
              fn: function() {
                return [
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-container",
                        { staticClass: "my-2", attrs: { fluid: "" } },
                        [
                          _c(
                            "b-card",
                            { attrs: { "bg-variant": "light" } },
                            [
                              _c(
                                "b-row",
                                {
                                  staticClass: "mt-2",
                                  attrs: { "align-h": "center" }
                                },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "4" } },
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "47%", height: "24%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "45%"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "4" } },
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "43%", height: "24%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "45%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                {
                                  staticClass: "mb-2",
                                  attrs: { "align-h": "center" }
                                },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "3" } },
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "43%", height: "24%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "45%"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "3" } },
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "40%", height: "24%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "45%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { attrs: { "align-h": "center" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "1" } },
                                    [
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "80%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-container",
                        { staticClass: "my-2", attrs: { fluid: "" } },
                        [
                          _c(
                            "b-card",
                            {
                              staticClass: "p-1",
                              attrs: { "bg-variant": "light", "no-body": "" }
                            },
                            [
                              _c(
                                "b-card",
                                {
                                  attrs: {
                                    "no-body": "",
                                    "bg-variant": "light"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center text-muted d-flex align-items-center justify-content-center"
                                    },
                                    [
                                      _c("div", { staticClass: "spinner" }, [
                                        _c("div", { staticClass: "rect1" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "rect2" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "rect3" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "rect4" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "rect5" })
                                      ]),
                                      _vm._v(" "),
                                      _c("h5", [_vm._v("Загрузка таблицы")])
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isBusy,
                expression: "!isBusy"
              }
            ]
          },
          [
            _c(
              "b-form",
              {
                on: {
                  submit: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.handleSubmit.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "b-card",
                  { staticClass: "custom-card mb-2" },
                  [
                    _c(
                      "b-row",
                      { attrs: { "align-h": "center" } },
                      [
                        _c(
                          "b-col",
                          { attrs: { lg: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group_organization",
                                  label: "Организация (продавец)",
                                  "label-for": "input_organization"
                                }
                              },
                              [
                                _c("organization-select", {
                                  ref: "organization_select",
                                  attrs: {
                                    id: "input-org-select",
                                    value: _vm.newItem.organization_id,
                                    state: _vm.getFieldState("organization_id")
                                  },
                                  on: { onSelect: _vm.onSelectOrg }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { lg: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group_customer",
                                  label: "Заказчик (покупатель)",
                                  "label-for": "input_customer"
                                }
                              },
                              [
                                _c("customer-select", {
                                  ref: "customer_select",
                                  attrs: {
                                    id: "input-customer-select",
                                    state: _vm.getFieldState("customer_id"),
                                    value: _vm.newItem.customer_id
                                  },
                                  on: { onSelect: _vm.onSelectCustomer }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { attrs: { "align-h": "center" } },
                      [
                        _c(
                          "b-col",
                          { attrs: { lg: "3" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-start-period",
                                  label: "Начало периода",
                                  "label-for": "input-start-period"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input-start-period",
                                    size: "sm",
                                    type: "date"
                                  },
                                  model: {
                                    value: _vm.startPeriod,
                                    callback: function($$v) {
                                      _vm.startPeriod = $$v
                                    },
                                    expression: "startPeriod"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { lg: "3" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-end-period",
                                  label: "Конец периода",
                                  "label-for": "input-end-period"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input-end-period",
                                    size: "sm",
                                    type: "date"
                                  },
                                  model: {
                                    value: _vm.endPeriod,
                                    callback: function($$v) {
                                      _vm.endPeriod = $$v
                                    },
                                    expression: "endPeriod"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "custom-btn-secondary",
                            on: {
                              click: function($event) {
                                return _vm.getDetails()
                              }
                            }
                          },
                          [
                            _c("v-icon", {
                              attrs: { name: "buttons/fill", size: 13 }
                            }),
                            _vm._v(
                              "\n                  Заполнить\n                "
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-table-container" },
              [
                _c("b-table", {
                  ref: "act_details",
                  staticClass: "custom-table mb-0 text-small",
                  attrs: {
                    id: "act-details",
                    "sticky-header": "",
                    selectable: "",
                    "select-mode": "single",
                    responsive: "",
                    "show-empty": "",
                    "empty-text": _vm.$t("message.common.emptyTable"),
                    busy: _vm.isBusy,
                    items: _vm.details.items,
                    fields: _vm.detailsFields,
                    "no-provider-filtering": "",
                    "no-provider-paging": "",
                    "no-provider-sorting": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "table-busy",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticClass: "text-center text-success my-2" },
                            [
                              _c("b-spinner", { staticClass: "align-middle" }),
                              _vm._v(" "),
                              _c("strong", [_vm._v("Загрузка")])
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "thead-top",
                      fn: function(data) {
                        return [
                          _c(
                            "b-tr",
                            [
                              _c(
                                "b-th",
                                {
                                  staticClass: "text-right",
                                  attrs: { colspan: "3" }
                                },
                                [_vm._v("Сальдо начальное")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-th",
                                [
                                  _c("b-form-input", {
                                    staticClass: "act-details-debit",
                                    attrs: {
                                      id: "input-start-saldo-debit",
                                      size: "sm"
                                    },
                                    model: {
                                      value: _vm.newItem.start_debit,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.newItem,
                                          "start_debit",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "newItem.start_debit"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-th",
                                [
                                  _c("b-form-input", {
                                    staticClass: "act-details-credit",
                                    attrs: {
                                      id: "input-start-saldo",
                                      size: "sm"
                                    },
                                    model: {
                                      value: _vm.newItem.start_credit,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.newItem,
                                          "start_credit",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "newItem.start_credit"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "custom-foot",
                      fn: function(data) {
                        return [
                          _c(
                            "b-tr",
                            [
                              _c(
                                "b-th",
                                {
                                  staticClass: "text-right",
                                  attrs: { colspan: "3" }
                                },
                                [_vm._v("Обороты")]
                              ),
                              _vm._v(" "),
                              _c("b-th", [
                                _c(
                                  "div",
                                  { staticClass: "act-details-debit" },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.priceFormat(_vm.totalDebit)
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c(
                                  "div",
                                  { staticClass: "act-details-credit" },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.priceFormat(_vm.totalCredit)
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tr",
                            [
                              _c(
                                "b-th",
                                {
                                  staticClass: "text-right",
                                  attrs: { colspan: "3" }
                                },
                                [_vm._v("Конечное сальдо")]
                              ),
                              _vm._v(" "),
                              _c("b-th", [
                                _c(
                                  "div",
                                  { staticClass: "act-details-debit" },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.priceFormat(_vm.endSaldoDebit)
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c(
                                  "div",
                                  { staticClass: "act-details-credit" },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.priceFormat(_vm.endSaldoCredit)
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(invoice_numb)",
                      fn: function(row) {
                        return [
                          _c(
                            "b-button",
                            {
                              staticStyle: { padding: "0px" },
                              attrs: { size: "sm", variant: "link" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.onInvoice(row.item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(row.item.invoice_numb) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(entity_date)",
                      fn: function(row) {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.formatTableDate(row.item.entity_date)
                              ) +
                              "\n              "
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(name)",
                      fn: function(row) {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.getName(row.item)) +
                              "\n              "
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(debit)",
                      fn: function(row) {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.priceFormat(row.item.debit)) +
                              "\n              "
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(credit)",
                      fn: function(row) {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.priceFormat(row.item.credit)) +
                              "\n              "
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(active)",
                      fn: function(row) {
                        return [
                          !row.item.active
                            ? _c("font-awesome-icon", {
                                attrs: { icon: "times" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          row.item.active
                            ? _c("font-awesome-icon", {
                                attrs: { icon: "check" }
                              })
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("export-file", { ref: "exportFile" })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f0a99d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f0a99d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReconciliationActs/ReconciliationAct.vue
// module id = null
// module chunks = 